import { gql } from "@apollo/client";

export const GET_USERS = gql`
  query getUsers {
    organizations: organization {
      org_id
      name
      type
    }
    user {
      user_id
      email
      role
      name
      accepted_terms_of_use
      updated_at
      created_at
      picture_url
      org_id
      organization {
        organization {
          name
          org_id
          type
        }
      }
      tags {
        tag {
          tag_id
          name
          type
        }
      }
      equipped_store_items(where: { item_type: { _eq: "PET" } }) {
        item_type
        store_item {
          store_item_id
          name
          slug
          type
          rarity
          asset_key
        }
      }
    }
  }
`;

export const GET_USER_BY_ROLE = gql`
  query getUserByRole($role: String!) {
    user(where: { role: { _eq: $role } }) {
      user_id
      email
      role
      name
      accepted_terms_of_use
      updated_at
      created_at
      picture_url
    }
  }
`;

export const GET_USERS_BY_ORG_ID_AND_ROLE = gql`
  query getUsersByOrgIdAndRole($orgId: uuid!, $role: String!) {
    organization_user(
      where: { org_id: { _eq: $orgId }, user: { role: { _eq: $role } } }
    ) {
      org_id
      user {
        user_id
        role
        name
        email
        picture_url
        equipped_store_items(where: { item_type: { _eq: "PET" } }) {
          item_type
          store_item {
            store_item_id
            name
            slug
            type
            rarity
            asset_key
          }
        }
      }
    }
  }
`;

export const GET_USER_BY_EMAIL = gql`
  query getUserByEmail($email: String!) {
    user(where: { email: { _eq: $email } }) {
      user_id
      email
      role
      name
      accepted_terms_of_use
      updated_at
      created_at
      picture_url
      tags {
        tag {
          tag_id
          name
          type
        }
      }
    }
  }
`;

export const GET_USER_BY_ID = gql`
  query getUserById($userId: uuid!) {
    user_by_pk(user_id: $userId) {
      user_id
      email
      role
      name
      accepted_terms_of_use
      sms_opt_in
      updated_at
      picture_url
      phone
      org_id
      tags {
        tag {
          tag_id
          name
          type
        }
      }
      badges {
        user_badge_id
        badge_id
        badge {
          badge_id
          name
          description
          icon_url
          criteria_type
          criteria_value
        }
      }
      organization {
        organization {
          org_id
          name
          logo_url
        }
      }
    }
    graduation_class_student(where: { student_id: { _eq: $userId } }) {
      graduation_class {
        name
        graduation_class_id
        program {
          org_id
          organization {
            org_id
            name
          }
        }
      }
    }
    mentoring(where: { mentee_id: { _eq: $userId } }) {
      mentoring_id
      mentor {
        user_id
        name
        email
        picture_url
        role
        org_id
      }
    }
  }
`;

export const GET_USER_PROFILE_STUDENT = gql`
  query getUserProfileStudent($userId: uuid!) {
    graduation_class_student(where: { student_id: { _eq: $userId } }) {
      graduation_class {
        program {
          organization {
            name
            type
            org_id
            logo_url
          }
        }
        current_academic_year {
          name
          academic_year_id
          end_date
        }
        name
        graduation_class_id
        current_academic_year_id
      }
      student {
        name
        email
        picture_url
        role
        sms_opt_in
        phone
      }
    }
  }
`;

export const GET_LEARNERS_BY_ORG_ID = gql`
  query getLearnersByOrgId($orgId: uuid!) {
    graduation_class(where: { program: { org_id: { _eq: $orgId } } }) {
      graduation_class_id
      name
      students {
        student {
          user_id
          email
          role
          name
          accepted_terms_of_use
          updated_at
          created_at
          picture_url
          org_id
          equipped_store_items(where: { item_type: { _eq: "PET" } }) {
            item_type
            store_item {
              store_item_id
              name
              slug
              type
              rarity
              asset_key
            }
          }
        }
      }
    }
  }
`;

export const GET_STUDENTS_BY_HOME_ORG = gql`
  query getStudentsByHomeOrg($orgId: uuid!) {
    user(where: { role: { _eq: "student" }, org_id: { _eq: $orgId } }) {
      user_id
      email
      role
      name
      picture_url
      updated_at
      created_at
      org_id
      equipped_store_items(where: { item_type: { _eq: "PET" } }) {
        item_type
        store_item {
          store_item_id
          name
          slug
          type
          rarity
          asset_key
        }
      }
    }
  }
`;

export const GET_USERS_ROLE_BY_ORG = gql`
  query getUsersRoleByOrg($orgId: uuid!, $role: String!) {
    organization_user(
      where: { org_id: { _eq: $orgId }, user: { role: { _eq: $role } } }
    ) {
      user {
        user_id
        email
        role
        name
        picture_url
        updated_at
        created_at
        equipped_store_items(where: { item_type: { _eq: "PET" } }) {
          item_type
          store_item {
            store_item_id
            name
            slug
            type
            rarity
            asset_key
          }
        }
      }
    }
  }
`;
